import { Component, OnInit, Input } from '@angular/core';


import { MercadoPagoService } from '../services/mercadopago.service';
import { CartService } from '../services/cart.service';
import { Observable, of } from 'rxjs';
import { CartItem } from 'src/app/modals/cart-item';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

declare function loadPaymentForm(arg: any): void;
declare function EjemploDesdeJS(): void;

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.sass'],

})

export class PaymentComponent implements OnInit {
    
  @Input('banners') banners: Array<any> = [];
  public contentLoaded : boolean = false; 
  public cartItems: Observable<CartItem[]> = of([]);
  public buyProducts: CartItem[] = [];
  amount: number;
  OrdenID:number=0;
  constructor(private cartService: CartService ,     
              public router: Router) {
    const navigation = this.router.getCurrentNavigation();
    let objeto = navigation?.extras?.state as { OrdenID: any };
    if (objeto != undefined) {

      this.OrdenID = objeto["OrdenID"];
    }else{

      this.router.navigate(['/pages/cart']);
    }

   }


      
ngOnInit() {

    this.cartItems = this.cartService.getItems();
    this.cartItems.subscribe(products => this.buyProducts = products);
    this.getTotal().subscribe(amount => this.amount = amount);

  

    loadPaymentForm({description:"ventaaaa",
                     amount:parseFloat(this.amount.toString()).toFixed(2),
                     quantity:1,
                     OrdenID:this.OrdenID,
                     APIURL: environment.apiUrl});
    this.contentLoaded = true;

  }
  
  public  LimpiarCarroJS() {
    this.cartService.removeAll();

  }
 
  public getTotal(): Observable<number> {
    return this.cartService.getTotalAmount();
  }



}



